import { useQuery } from "@tanstack/react-query";
import { fetchGuides } from "../network/globalFetches";
import { Guide } from "../types";
import { Autocomplete, TextField } from "@mui/material";

const GuideAutocompleteInput = ({
  onSelected,
  onChange,
}: {
  onSelected: (name: Guide) => void;
  onChange: (value: string) => void;
}) => {
  const { data } = useQuery({
    queryKey: fetchGuides.queryKey,
    queryFn: fetchGuides.fetch,
    staleTime: Infinity,
  });

  if (!data) return null;

  return (
    <Autocomplete
      options={data}
      getOptionLabel={(option) => option.name} // Display the label
      onChange={(_, newValue) => {
        if (newValue) {
          onSelected(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          onFocus={(e) => {
            onChange(e.target.value);
          }}
          onChange={(e) => onChange(e.target.value)}
          label="בחר מלווה מאשר"
          variant="outlined"
          sx={{
            "& .MuiInputBase-root": {
              fontSize: "0.8rem", // Smaller text inside the input
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.8rem", // Smaller label font
            },
          }}
        />
      )}
    />
  );
};

export default GuideAutocompleteInput;
